/**
 * Ticketing Module - Frontend JavaScript
 *
 * Handles ticket form interactions and calculations
 */

(function($) {
  "use strict";

  // Module state
  let selectedPerformance = null;
  let selectedEvent = null;
  let selectedCurrency = "€";
  let ticketQuantities = {};

  /**
   * Initialize the ticket form
   */
  function initTicketForm() {
    console.log("Initializing ticket form...");

    // Check if we need to populate performances (new template)
    if ($("#performance_id option").length <= 1 && yfTicketingData.performances) {
      console.log("Populating performance dropdown from data...");
      populatePerformances();
    }

    // Display errors if any (new template)
    if (yfTicketingData.errors && Object.keys(yfTicketingData.errors).length > 0) {
      displayErrors(yfTicketingData.errors);
    }

    // Restore form data if any (new template)
    if (yfTicketingData.formData) {
      restoreFormData(yfTicketingData.formData);
    }

    // Performance selection handler
    $("#performance_id").on("change", handlePerformanceChange);

    // Event selection handler
    $("#event_id").on("change", handleEventChange);

    // Restore form state if there was an error
    if ($("#performance_id").val()) {
      handlePerformanceChange();
    }
  }

  /**
   * Populate performance dropdown (for new Yfantis template)
   */
  function populatePerformances() {
    const $performanceSelect = $("#performance_id");

    // Keep the first option (placeholder)
    const $placeholder = $performanceSelect.find("option:first");
    $performanceSelect.empty().append($placeholder);

    if (!yfTicketingData.performances || yfTicketingData.performances.length === 0) {
      console.log("No performances available");
      return;
    }

    yfTicketingData.performances.forEach(function(perf) {
      const $option = $("<option></option>")
        .val(perf.id)
        .text(perf.name)
        .data("currency", perf.currency);

      $performanceSelect.append($option);
    });

    console.log("Populated " + yfTicketingData.performances.length + " performances");
  }

  /**
   * Display errors (for new Yfantis template)
   */
  function displayErrors(errors) {
    const $errorContainer = $("#yf-ticketing-errors");
    const $errorList = $("#yf-ticketing-error-list");

    if (!$errorContainer.length || !$errorList.length) {
      return; // Old template, errors already displayed by PHP
    }

    $errorList.empty();

    Object.keys(errors).forEach(function(field) {
      const $li = $("<li></li>").text(errors[field]);
      $errorList.append($li);
    });

    $errorContainer.show();
  }

  /**
   * Restore form data (for new Yfantis template)
   */
  function restoreFormData(formData) {
    if (formData.customer_name) {
      $("#customer_name").val(formData.customer_name);
    }
    if (formData.customer_email) {
      $("#customer_email").val(formData.customer_email);
    }
    if (formData.customer_city) {
      $("#customer_city").val(formData.customer_city);
    }
    if (formData.performance_id) {
      $("#performance_id").val(formData.performance_id);
    }
    if (formData.event_id) {
      $("#event_id").val(formData.event_id);
    }
  }

  /**
   * Handle performance selection
   */
  function handlePerformanceChange() {
    const performanceId = $("#performance_id").val();
    const currency = $("#performance_id option:selected").data("currency");

    if (!performanceId) {
      $("#event-selection").hide();
      $("#ticket-selection").hide();
      $("#customer-info").hide();
      $("#running-total").hide();
      return;
    }

    selectedPerformance = parseInt(performanceId);
    selectedCurrency = currency || "€";

    // Load events for this performance
    loadEvents(selectedPerformance);

    // Show event selection
    $("#event-selection").show();

    // Hide subsequent sections
    $("#ticket-selection").hide();
    $("#customer-info").hide();
    $("#running-total").hide();
  }

  /**
   * Load events for a performance
   */
  function loadEvents(performanceId) {
    const $eventSelect = $("#event_id");
    $eventSelect.empty();
    $eventSelect.append("<option value=\"\">-- Choose a date --</option>");

    if (!yfTicketingData.events[performanceId]) {
      return;
    }

    const events = yfTicketingData.events[performanceId];

    events.forEach(function(event) {
      const dateTime = formatDateTime(event.start_datetime);
      const location = event.location;
      const availability = yfTicketingData.availability[event.id];
      const isSoldOut = availability && availability.sold_out;

      let optionText = `${dateTime} - ${location}`;

      if (isSoldOut) {
        optionText += ` - ${yfTicketingData.i18n.soldOut}`;
      } else if (availability && availability.available > 0) {
        optionText += ` (${availability.available} ${yfTicketingData.i18n.tickets} ${yfTicketingData.i18n.available})`;
      }

      const $option = $("<option></option>")
        .val(event.id)
        .text(optionText)
        .data("event", event);

      // Disable sold-out events
      if (isSoldOut) {
        $option.prop("disabled", true);
        $option.addClass("sold-out");
      }

      $eventSelect.append($option);
    });
  }

  /**
   * Handle event selection
   */
  function handleEventChange() {
    const eventId = $("#event_id").val();

    if (!eventId) {
      $("#ticket-selection").hide();
      $("#customer-info").hide();
      $("#running-total").hide();
      return;
    }

    selectedEvent = parseInt(eventId);

    // Load ticket types for this event
    loadTicketTypes(selectedEvent);

    // Show ticket selection
    $("#ticket-selection").show();
    $("#running-total").show();

    // Reset quantities
    ticketQuantities = {};
    updateTotal();
  }

  /**
   * Load ticket types for an event
   */
  function loadTicketTypes(eventId) {
    const $container = $("#ticket-types-container");
    $container.empty();

    if (!yfTicketingData.ticketTypes[eventId]) {
      $container.html("<p>No tickets available for this event.</p>");
      return;
    }

    const ticketTypes = yfTicketingData.ticketTypes[eventId];

    ticketTypes.forEach(function(ticketType) {
      const ticketHtml = createTicketTypeHtml(ticketType);
      $container.append(ticketHtml);
    });

    // Attach event handlers
    $(".ticket-quantity").on("change", handleQuantityChange);
    $(".ticket-plus").on("click", handlePlusClick);
    $(".ticket-minus").on("click", handleMinusClick);
  }

  /**
   * Create HTML for a ticket type
   */
  function createTicketTypeHtml(ticketType) {
    const price = formatPrice(ticketType.price);

    return `
            <div class="ticket-type-row" data-tickettype-id="${ticketType.id}">
                <div class="ticket-type-info">
                    <strong class="ticket-type-name">${escapeHtml(ticketType.name)}</strong>
                    <span class="ticket-type-price">${price}</span>
                </div>
                <div class="ticket-type-quantity">
                    <button type="button" class="btn btn-sm btn-secondary ticket-minus" data-tickettype-id="${ticketType.id}">-</button>
                    <input type="number" 
                           name="ticket_quantities[${ticketType.id}]" 
                           class="form-control ticket-quantity" 
                           data-tickettype-id="${ticketType.id}"
                           data-price="${ticketType.price}"
                           min="0" 
                           max="99" 
                           value="0">
                    <button type="button" class="btn btn-sm btn-secondary ticket-plus" data-tickettype-id="${ticketType.id}">+</button>
                </div>
            </div>
        `;
  }

  /**
   * Handle quantity change
   */
  function handleQuantityChange(e) {
    const $input = $(e.target);
    const ticketTypeId = $input.data("tickettype-id");
    const quantity = parseInt($input.val()) || 0;

    ticketQuantities[ticketTypeId] = quantity;

    updateTotal();
    updateCustomerInfoVisibility();
  }

  /**
   * Handle plus button click
   */
  function handlePlusClick(e) {
    e.preventDefault();
    const ticketTypeId = $(e.target).data("tickettype-id");
    const $input = $(`.ticket-quantity[data-tickettype-id="${ticketTypeId}"]`);
    const currentValue = parseInt($input.val()) || 0;
    const maxValue = parseInt($input.attr("max")) || 99;

    if (currentValue < maxValue) {
      $input.val(currentValue + 1).trigger("change");
    }
  }

  /**
   * Handle minus button click
   */
  function handleMinusClick(e) {
    e.preventDefault();
    const ticketTypeId = $(e.target).data("tickettype-id");
    const $input = $(`.ticket-quantity[data-tickettype-id="${ticketTypeId}"]`);
    const currentValue = parseInt($input.val()) || 0;
    const minValue = parseInt($input.attr("min")) || 0;

    if (currentValue > minValue) {
      $input.val(currentValue - 1).trigger("change");
    }
  }

  /**
   * Update running total
   */
  function updateTotal() {
    let total = 0;
    let isFreeEvent = true;

    $(".ticket-quantity").each(function() {
      const quantity = parseInt($(this).val()) || 0;
      const price = parseFloat($(this).data("price")) || 0;
      total += quantity * price;

      // Check if any ticket has a price > 0
      if (price > 0) {
        isFreeEvent = false;
      }
    });

    // Update total display - show "Free" for free events
    if (isFreeEvent && total === 0) {
      $("#total-amount").text(yfTicketingData.i18n.free || "Free");
    } else {
      $("#total-amount").text(formatPrice(total));
    }

    // Update submit button text based on event type
    updateSubmitButtonText(isFreeEvent);
  }

  /**
   * Update submit button text for free vs paid events
   */
  function updateSubmitButtonText(isFreeEvent) {
    const $submitBtn = $("#yf-ticket-submit-btn");

    if (isFreeEvent) {
      // Free event - change to "Complete Registration"
      $submitBtn.text(yfTicketingData.i18n.completeRegistration || "Complete Registration");
    } else {
      // Paid event - "Continue to Payment"
      $submitBtn.text(yfTicketingData.i18n.continueToPayment || "Continue to Payment");
    }
  }

  /**
   * Show/hide customer info based on ticket selection
   */
  function updateCustomerInfoVisibility() {
    const hasTickets = Object.values(ticketQuantities).some(qty => qty > 0);

    if (hasTickets) {
      $("#customer-info").show();
    } else {
      $("#customer-info").hide();
    }
  }

  /**
   * Format price with currency symbol
   */
  function formatPrice(amount) {
    return selectedCurrency + " " + parseFloat(amount).toFixed(2);
  }

  /**
   * Format date and time
   */
  function formatDateTime(datetime) {
    // Simple formatting - can be enhanced with moment.js or Intl.DateTimeFormat
    const date = new Date(datetime);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    };
    return date.toLocaleDateString("nl-NL", options);
  }

  /**
   * Escape HTML to prevent XSS
   */
  function escapeHtml(text) {
    const map = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      "\"": "&quot;",
      "'": "&#039;"
    };
    return text.replace(/[&<>"']/g, function(m) {
      return map[m];
    });
  }

  /**
   * Client-side form validation
   */
  function validateForm() {
    let isValid = true;
    const errors = [];

    // Check if tickets are selected
    const hasTickets = Object.values(ticketQuantities).some(qty => qty > 0);
    if (!hasTickets) {
      errors.push("Please select at least one ticket");
      isValid = false;
    }

    // Check customer name
    const name = $("#customer_name").val().trim();
    if (!name) {
      errors.push("Please enter your name");
      isValid = false;
    }

    // Check customer email
    const email = $("#customer_email").val().trim();
    if (!email) {
      errors.push("Please enter your email");
      isValid = false;
    } else if (!isValidEmail(email)) {
      errors.push("Please enter a valid email address");
      isValid = false;
    }

    if (!isValid) {
      alert(errors.join("\n"));
    }

    return isValid;
  }

  /**
   * Validate email format
   */
  function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  /**
   * Form submission handler
   */
  function handleFormSubmit(e) {
    if (!validateForm()) {
      e.preventDefault();
      return false;
    }

    // Form is valid, allow submission
    return true;
  }

  // Initialize when document is ready
  $(document).ready(function() {
    if ($("#yf-ticket-form").length > 0) {
      initTicketForm();

      // Attach form submission handler
      $("#yf-ticket-form").on("submit", handleFormSubmit);
    }
  });

})(jQuery);
